import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { parseLocalDate } from './parse-local-date';

/**
 * Checks if the input date is <= a given date (ignoring time).
 *
 * `maxDateOrOffset` can be:
 *  - Date: compares against that date
 *  - number: compares against (today + offsetDays)
 *
 * Defaults to today (offset 0).
 */
export function dateLessThanEqualValidator(
  maxDateOrOffset: Date | number = 0
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const inputDate = parseLocalDate(control.value);
    if (Number.isNaN(inputDate.getTime())) {
      return { dateNotLessOrEqual: true };
    }
    inputDate.setHours(0, 0, 0, 0);

    const compareDate = typeof maxDateOrOffset === 'number' ? new Date() : new Date(maxDateOrOffset);
    compareDate.setHours(0, 0, 0, 0);
    if (typeof maxDateOrOffset === 'number') {
      compareDate.setDate(compareDate.getDate() + Math.trunc(maxDateOrOffset));
    }

    return inputDate <= compareDate
      ? null
      : {
        dateNotLessOrEqual: {
          requiredDate: compareDate
        },
      };
  };
}
